import { supabase } from '../../lib/supabase'

export type SwapDecisionKind = 'approve' | 'deny'

export type DecideShiftSwapParams = {
  swapId: string
  decision: SwapDecisionKind
  comment?: string
}

export type SwapDecisionResult = { ok: true } | { ok: false; message: string }

// The only path to approve or deny a swap: v1-decide-shift-swap records the
// decision and, for an approval, exchanges the two shifts and amends each
// published pay period the swap touches in one transaction. A refusal carries
// its reason (a period no longer published, an agent no longer holding the
// shift), which the supervisor reads rather than a generic failure.
export async function decideShiftSwap(params: DecideShiftSwapParams): Promise<SwapDecisionResult> {
  const { error } = await supabase.functions.invoke('v1-decide-shift-swap', { body: params })
  if (!error) return { ok: true }

  let message = error.message
  const context = (error as { context?: { json?: () => Promise<{ error?: string }> } }).context
  if (context?.json) {
    try {
      const body = await context.json()
      if (body.error) message = body.error
    } catch {
      // The body was not JSON; the error's own message stands.
    }
  }
  return { ok: false, message: message || 'The decision could not be recorded.' }
}
